module.exports = __webpack_public_path__ + "static/img/product_society_society_jczz.c9ea43d.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_society_jczz.svg
// module id = aQZ1
// module chunks = 0